import type { ReactNode } from 'react';

type ChartPlotProps = {
  children: ReactNode;
};

export const ChartPlot = ({ children }: ChartPlotProps) => {
  return <div className="h-full w-full style={{ gridArea: 'plot' }}">{children}</div>;
};
